import colors from '../colors.module.scss';
/**
 * Gets color class for breakdown indicators
 */
export const getBreakdownIndicatorColor = (index, totalCards) => {
    const colorPosition = (index % 3) + 1;
    const multipleRows = totalCards > 3;
    const isTopRow = index < 3;
    const useLighten50 = !multipleRows || !isTopRow;
    const suffix = useLighten50 ? 'Lighten50' : '';
    return colors[`position${colorPosition}${suffix}`];
};
/**
 * Gets color class for progress bar segments
 */
export const getProgressBarColor = (index, totalCards) => {
    const colorPosition = (index % 3) + 1;
    const multipleRows = totalCards > 3;
    const isTopRow = index < 3;
    const useLighten50 = !multipleRows || !isTopRow;
    const suffix = useLighten50 ? 'Lighten50' : '';
    return colors[`position${colorPosition}${suffix}`];
};
/**
 * Gets color class for funding cards based on row logic
 *  Single row: all cards use lighten-50
 *  Multiple rows: top row cards use base colors, others use lighten-50
 */
export const getFundingCardColor = (position, multipleRows, isTopRow) => {
    const colorPosition = (position % 3) + 1;
    const useLighten50 = !multipleRows || !isTopRow;
    const suffix = useLighten50 ? 'Lighten50' : '';
    return colors[`position${colorPosition}${suffix}`];
};
